import { SortedSymbols } from '@flipster/apis/v2/market/types';

import { getSymbolsByDataRef } from '../market-layout';

/**
 * quote currency pair 목록의 dataRef 규약.
 * 서버 market layout 의 SUBSECTION_* 노드는 소문자 통화 코드를 dataRef 로 내려주고,
 * 같은 키가 `data`(SortedSymbols)에 담긴다: SUBSECTION_{CODE} → dataRef '{code}' → data['{code}']
 *
 * 통화별 매핑 테이블 대신 규약으로 해석하므로, 새 quote currency 가 추가돼도 이 파일은 그대로다.
 */
export const getQuoteCurrencyDataRef = (currency: string): string => currency.toLowerCase();

/** 해당 quote currency pair 의 심볼 목록을 data(SortedSymbols)에서 추출한다. */
export const getQuoteCurrencyPairSymbols = (data: SortedSymbols | undefined, currency: string): string[] =>
  getSymbolsByDataRef(data, getQuoteCurrencyDataRef(currency));
